module.exports = __webpack_public_path__ + "static/media/pigo_1.5823f906.png";